import Mapbox from 'components/mapbox';
import Mediator from 'common/scripts/mediator';

const mediator = new Mediator();
const Mapboxgl = window.mapboxgl;

import tmplTooltip from 'components/mapbox/mapbox-tooltip.twig';
import tmplTooltipIcon from 'components/mapbox/mapbox-tooltip-icon.twig';
import Utils from 'common/scripts/utils';

if (Mapboxgl) {
    Mapboxgl.accessToken =
        'pk.eyJ1Ijoic2FtdWVsNzEzIiwiYSI6ImNrcHBqNnl5aDBueXUycG1uNGp2MGJwc2wifQ.cX_qStxHELOtBYnH2ABRdA';
}

const PANEL_ICON_CLASS = 'mapbox-popup__panel_theme_icon';


export default class MapboxPopup extends Mapbox {
    constructor() {
        super();
        this.opens = [];
        this.containerPopup = null;
        this.close = null;
        this.panel = null;
        this.tooltipBtnClose = null;
    }

    initPopup(containerPopup, popupOpenElements) {
        this._initElements(containerPopup, popupOpenElements);
        this._bindEventsPopup();
        this.setMapReady();
    }

    _initElements(containerPopup, popupOpenElements) {
        this.opens = Array.from(popupOpenElements);
        this.containerPopup = containerPopup;
        this.close = this.containerPopup.querySelector('.j-mapbox-popup-close');
        this.panel = this.containerPopup.querySelector('.j-mapbox-popup-panel');
    }

    _bindEventsPopup() {
        mediator.subscribe('mapReady', () => {
            if (this.markerElems && this.markerElems.length) {
                this.markerElems.forEach((element) => {
                    return this._addClickMarker(element);
                });
            }
            if (this.iconElems && this.iconElems.length) {
                this.iconElems.forEach((element) => {
                    return this._addClickIcon(element);
                });
            }
        });

        if (this.close) {
            this.close.addEventListener('click', (event) => {
                event.preventDefault();

                this.toClose();
            });
        }

        if (this.opens && this.opens.length) {
            this.opens.forEach((open) => {
                open.addEventListener('click', this.toOpen.bind(this));
            });
        }

        window.addEventListener('resize', Utils.debounce(this._checkVisible.bind(this), 100));
    }

    _checkVisible() {
        if (!this.isOpen()) {
            return;
        }

        if (window.innerWidth >= 960) {
            this.toClose();
        }
    }

    _addClickMarker(element) {
        element.addEventListener('click', () => {
            const id = element.dataset.id;

            if (!this.data.markers || !this.data.markers.length) {
                return;
            }
            const currentMarker = this.data.markers.find((marker) => {
                return Number(marker.id) === Number(id);
            });

            if (element.classList.contains(this.activeClass)) {
                this.activeOnlyMarker();
                this.hidePanel();
            } else {
                this.activeOnlyMarker(id);
                this.showPanel(tmplTooltip(currentMarker));
            }
        });
    }

    _addClickIcon(element) {
        element.addEventListener('click', () => {
            const id = element.dataset.id;

            if (!this.data.icons || !this.data.icons.length) {
                return;
            }
            const currentIcon = this.data.icons.find((icon) => {
                return Number(icon.id) === Number(id);
            });

            if (element.classList.contains(this.activeClass)) {
                this.activeOnlyMarker();
                this.panel.classList.remove(PANEL_ICON_CLASS);
                this.hidePanel();
            } else {
                this.activeOnlyMarker(id);
                this.panel.classList.add(PANEL_ICON_CLASS);
                this.showPanel(tmplTooltipIcon(currentIcon));
            }
        });
    }

    showPanel(tmpl) {
        Utils.clearHtml(this.panel);
        this.panel.insertAdjacentHTML('beforeend', tmpl);
        Utils.show(this.panel);
        this.initTooltipBtnClose();
    }

    hidePanel() {
        Utils.clearHtml(this.panel);
        Utils.hide(this.panel);
    }

    initTooltipBtnClose() {
        this.tooltipBtnClose = this.panel.querySelector('.j-tooltip-icon-close');
        if (this.tooltipBtnClose) {
            this.tooltipBtnClose.addEventListener('click', this.hidePanel.bind(this));
        }
    }

    activeOnlyMarker(id = -1) {
        this.markerElems.forEach((marker) => {
            if (Number(marker.dataset.id) === Number(id)) {
                marker.classList.add(this.activeClass);
            } else {
                marker.classList.remove(this.activeClass);
            }
        });
    }

    isOpen() {
        return this.containerPopup.style.display !== 'none';
    }

    toOpen() {
        Utils.show(this.containerPopup, 'flex');
        Utils.bodyFixed(this.containerPopup);

        setTimeout(() => {
            if (this.map) {
                this.map.resize();
            }
        }, 0);
    }

    toClose() {
        Utils.hide(this.containerPopup);
        Utils.bodyStatic();
    }
}
